import FormInputNumber from '@components/forms/FormInputNumber';

export default function WrestlerStatsForm() {
    return (
        <FormInputNumber
            name="weight"
            label="Weight"
            tooltip={`Wrestler weight will be used to more accurately place the wrestler into weight classes.`}
            units={'lbs'}
        />
    );
}
